import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Input } from "@/components/erp/ui";
import { FileCheck2, Upload } from "lucide-react";

// Bukti Faktur Pajak invoice (wajib diupload Finance setelah pembayaran masuk)
export const FakturProof = ({ inv, onSaved }) => {
  const [no, setNo] = useState(inv.faktur_pajak || ""); const [busy, setBusy] = useState(false);
  if (!(inv.tax > 0)) return null;
  const paid = (inv.termins || []).some((t) => t.paid);
  const ff = inv.faktur_file;
  const up = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file); fd.append("number", no);
    setBusy(true);
    try { const { data } = await api.post(`/invoices/${inv.id}/faktur-proof`, fd); toast.success("Bukti Faktur Pajak tersimpan"); onSaved({ ...inv, ...data }); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal upload"); }
    setBusy(false);
  };
  const open = async () => { const res = await api.get(`/invoices/${inv.id}/faktur-proof`, { responseType: "blob" }); window.open(URL.createObjectURL(res.data), "_blank"); };
  return (
    <div data-testid="faktur-proof" className={`rounded-lg border px-3 py-2 text-xs ${ff ? "border-emerald-200 bg-emerald-50" : paid ? "border-violet-300 bg-violet-50" : "border-slate-200"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <FileCheck2 className={`w-4 h-4 ${ff ? "text-emerald-600" : "text-violet-600"}`} />
        <b className="flex-1" data-testid="faktur-proof-status">{ff ? `Bukti Faktur Pajak diupload ${ff.at.slice(0, 10)} oleh ${ff.by}` : paid ? "Wajib: upload bukti Faktur Pajak (pembayaran sudah masuk)" : "Bukti Faktur Pajak diupload setelah pembayaran"}</b>
        {ff && <button type="button" data-testid="faktur-proof-open" onClick={open} className="text-sky-700 underline">Lihat bukti</button>}
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-2">
        <Input data-testid="faktur-proof-number" className="!h-8 !w-56" placeholder="No. Faktur Pajak" value={no} onChange={(e) => setNo(e.target.value)} />
        <label data-testid="faktur-proof-upload" className={`inline-flex items-center gap-1 h-8 px-3 rounded-lg border border-slate-300 bg-white cursor-pointer hover:border-sky-500 ${busy ? "opacity-50 pointer-events-none" : ""}`}>
          <input type="file" accept=".pdf,image/*" className="hidden" data-testid="faktur-proof-file" onChange={(e) => up(e.target.files?.[0])} />
          <Upload className="w-4 h-4" /> {busy ? "Mengupload…" : ff ? "Ganti bukti" : "Upload bukti"}</label>
      </div>
    </div>
  );
};
